import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cstp-target-characteristics',
  templateUrl: './cstp-target-characteristics.component.html',
  styleUrls: ['./cstp-target-characteristics.component.css']
})
export class CstpTargetCharacteristicsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
